export function getMetaContent(name) {
  const el = document.querySelector(`meta[name="${name}"]`);
  return el ? el.getAttribute("content") : null;
}

const currentUserId = getMetaContent("current-user-id");
if (currentUserId) {
  window.CURRENT_USER_ID = currentUserId;
}
